import { axios, type MutationFetcher, type SWRKey, useSWRMutation } from 'services/swr';

export const npsStorageKeys = {
    submitted: 'md_nps.submitted',
    snoozeUntil: 'md_nps.snoozeUntilMs',
    visits: 'md_nps.dashboardVisits',
    resultsVisits: 'md_nps.resultsVisits',
    lastResultId: 'md_nps.lastResultId',
    pendingResultsPrompt: 'md_nps.pendingResultsPrompt',
} as const;

const sendNpsScore: MutationFetcher<unknown, SWRKey, unknown> = async ({ url, ...config }, { arg: data }) => {
    const res = await axios.post(url, data, config);
    return res.data;
};

export const useSendNpsScore = () => {
    const reportKey: SWRKey = { url: '/v4/apikey/nps' };
    return useSWRMutation(reportKey, sendNpsScore, { revalidate: false });
};
